module.exports = __webpack_public_path__ + "img/Wagner-HR-199x200.a52df21c.png";